import { commonCbEnv } from "./env.cb.common";

const env: Partial<typeof commonCbEnv> = {
  production: true,
  page: 'moneysmart',
  meta: {
    siteTitle: 'Caruta cu bani - Moneysmart',
    ogSiteName: 'Caruta Cu Bani',
    siteDescription: '',
    ogImageAlt: '',
    ogUrl: 'https://carutacubani.ro/cursuri/moneysmart/',
    ogImage: 'https://carutacubani.ro/cursuri/moneysmart/assets/images/moneysmart/cover-fb.png'
  }
};

export const environment = { ...commonCbEnv, ...env };
